import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  Divider,
  List,
  ListItem,
  ListItemText,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Button,
  Menu,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Styles from "../Dashboard.module.scss";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ActiveProjects from "../../../assets/images/active_projects.svg";
import TotalTask from "../../../assets/images/total_task.svg";
import TotalInProgress from "../../../assets/images/TotalInProgress.svg";
import TotalCompleted from "../../../assets/images/TotalCompleted.svg";
import TotalProduction from "../../../assets/images/TotalProduction.svg";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Active_Projects from "../../../assets/images/Dashboard/Active_Projects.png";
import Total_Completed from "../../../assets/images/Dashboard/Total_Completed.png";
import Total_Production from "../../../assets/images/Dashboard/Total_Production.png";
import Total_Progress from "../../../assets/images/Dashboard/Total_Progress.png";
import Total_Task from "../../../assets/images/Dashboard/Total_Task.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// Import modules from swiper/modules
import { Navigation } from "swiper/modules";
import { Pagination } from "swiper/modules";
import Production_NoData from "../../../assets/images/Production_NoData.svg";
import PublicHoliday_NoData from "../../../assets/images/Public_Holiday_NoData.svg";
import dayjs from "dayjs";

const ClientDashboard = ({
  clientData,
  handleDateChange,
  handleMenuClick,
  handleMenuClose,
  isMenuOpen,
  anchorEl,
  selectedDate,
  clientProject,
  selectedClientProject,
  setSelectedClientProject,
  getAllCalendarData, // optional prop for fetching all calendar data
}) => {
  // Independent calendar filter state
  const [calendarSelectedDate, setCalendarSelectedDate] = useState(dayjs());
  const [allCalendarData, setAllCalendarData] = useState([]);

  // Fetch all calendar data once on mount
  useEffect(() => {
    async function fetchAllCalendarData() {
      if (getAllCalendarData) {
        const data = await getAllCalendarData();
        setAllCalendarData(data);
      } else if (clientData?.publicHoliday) {
        setAllCalendarData(clientData.publicHoliday);
      }
    }
    fetchAllCalendarData();
  }, []);

  const navigate = useNavigate();
  const clientConfig = [
    {
      img: ActiveProjects,
      title: "Active Projects",
      value: `${clientData.totalClientProject || 0}`,
      color: "#EBF5FF",
      borderColor: "#2B6AB1",
      SubBoxColor: "#C5DEF8",
      SubBoxImage: Active_Projects,
    },
    {
      img: TotalTask,
      title: "Total Tasks",
      value: `${clientData.totalClientTask || 0}`,
      color: "#F4EDFF",
      borderColor: "#573AA8",
      SubBoxColor: "#DECDF9",
      SubBoxImage: Total_Task,
    },
    {
      img: TotalInProgress,
      title: "Total In Progress",
      value: `${clientData.totalInProgress || 0}`,
      color: "#E8FFF9",
      borderColor: "#327B68",
      SubBoxColor: "#C1F3E6",
      SubBoxImage: Total_Production,
    },
    {
      img: TotalCompleted,
      title: "Total Completed",
      value: `${clientData.totalCompleted || 0}`,
      color: "#F1FFEB",
      borderColor: "#21A600",
      SubBoxColor: "#D6F5C9",
      SubBoxImage: Total_Progress,
    },
    {
      img: TotalProduction,
      title: "Total Production",
      value: `${clientData.totalProduction || 0}`,
      color: "#FFF7EC",
      borderColor: "#FFB657",
      SubBoxColor: "#FFEBCF",
      SubBoxImage: Total_Completed,
    },
  ];
  // Add these helper functions
  const getDaySuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const generateCalendarDays = () => {
    const currentDate = selectedDate.toDate();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();

    // Get first day of month
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    // Get days from previous month to fill first week
    const startingDayOfWeek = firstDay.getDay();
    const daysFromPrevMonth = startingDayOfWeek;

    // Get days from next month to fill last week
    const totalDays = lastDay.getDate();
    const endingDayOfWeek = lastDay.getDay();
    const daysFromNextMonth = 6 - endingDayOfWeek;

    const days = [];

    // Add previous month's days
    const prevMonthLastDay = new Date(year, month, 0).getDate();
    for (
      let i = prevMonthLastDay - daysFromPrevMonth + 1;
      i <= prevMonthLastDay;
      i++
    ) {
      days.push({
        date: new Date(year, month - 1, i),
        isCurrentMonth: false,
        isHoliday: false,
      });
    }

    // Add current month's days
    for (let i = 1; i <= totalDays; i++) {
      const dayDate = new Date(year, month, i);
      const isHoliday = checkIfHoliday(dayDate);
      const isToday = dayjs(dayDate).isSame(dayjs(), "day");
      days.push({
        date: dayDate,
        isCurrentMonth: true,
        isHoliday: isHoliday,
        isToday,
      });
    }

    // Add next month's days
    for (let i = 1; i <= daysFromNextMonth; i++) {
      days.push({
        date: new Date(year, month + 1, i),
        isCurrentMonth: false,
        isHoliday: false,
      });
    }

    return days;
  };

  const checkIfHoliday = (date) => {
    if (!clientData?.publicHoliday) return false;

    return clientData.publicHoliday.some((holiday) => {
      const holidayDate = new Date(holiday.date);
      return (
        holidayDate.getDate() === date.getDate() &&
        holidayDate.getMonth() === date.getMonth() &&
        holidayDate.getFullYear() === date.getFullYear()
      );
    });
  };
  const ProgressItem = ({ label, value }) => (
    <Box
      sx={{
        textAlign: "center",
        mx: "auto",
        py: 1,
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontSize: "14px",
          fontWeight: 500,
          fontFamily: "Inter, sans-serif",
        }}
      >
        {label}
      </Typography>
      <Box sx={{ position: "relative", display: "inline-flex", padding: 0 }}>
        {/* Background Circle */}
        <CircularProgress
          variant="determinate"
          value={100} // Full circle
          size={125} // Medium size
          thickness={5}
          sx={{ color: "#F5F5F5", position: "absolute" }}
        />
        {/* Foreground Circle */}
        <CircularProgress
          variant="determinate"
          value={value}
          size={125} // Medium size
          thickness={5}
          sx={{ color: "#008080" }} // Foreground color
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6" component="div">
            {`${value}%`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
          }}
        >
          <Box className={Styles.MainCard}>
            <Typography variant="h6" className={Styles.HeaderTitle}>
              Project Analytics
            </Typography>
            <Grid container mt={2} spacing={2}>
              {clientConfig?.map((item, index) => (
                <Grid
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 2.4,
                    lg: 2.4,
                  }}
                  key={index}
                >
                  <Card
                    className={Styles.CardDesign}
                    style={{
                      backgroundColor: item.color,
                      "--border-color": item.borderColor,
                    }}
                  >
                    <Stack
                      direction={"row"}
                      width={"100%"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                      padding={"0px 12px 0px 18px"}
                    >
                      <Stack spacing={0.5}>
                        <Typography
                          variant="subtitle1"
                          className={Styles.Title}
                        >
                          {item.title}
                        </Typography>
                        <Typography variant="h4" className={Styles.Value}>
                          {item.value}
                        </Typography>
                      </Stack>
                      <Stack
                        sx={{
                          background: item.SubBoxColor,
                          padding: "5px",
                          borderRadius: "10px",
                        }}
                      >
                        <img
                          src={item.SubBoxImage}
                          alt="LMT-Logo"
                          style={{
                            height: "25px",
                            width: "25px",
                          }}
                        />
                      </Stack>
                    </Stack>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>

        {/* Left Section - 8 Columns */}
        <Grid
          size={{ xs: 12, sm: 12, md: 7, lg: 8 }}
          sx={{
            width: "100%",
            overflow: "scroll",
            height: "100vh",
          }}
          className="no-scrollbar"
        >
          <Grid sx={{ position: "relative" }}>
            <Card className={Styles.TableCard}>
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Typography
                  variant="h6"
                  sx={{
                    ml: 2,
                    fontSize: "16px",
                    fontWeight: 600,
                    lineHeight: "24px",
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  Task Overview
                </Typography>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div>
                    <Button
                      id="calendar-button"
                      aria-controls={isMenuOpen ? "calendar-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={isMenuOpen ? "true" : undefined}
                      onClick={handleMenuClick}
                      style={{
                        color: "#008080",
                        fontSize: "14px",
                        fontWeight: 500,
                        textTransform: "capitalize",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      {selectedDate.format("MMMM YYYY")}{" "}
                      <KeyboardArrowDownOutlinedIcon
                        sx={{ fontSize: "24px" }}
                      />
                    </Button>
                    <Menu
                      id="calendar-menu"
                      anchorEl={anchorEl}
                      open={isMenuOpen}
                      onClose={handleMenuClose}
                      MenuListProps={{
                        "aria-labelledby": "calendar-button",
                      }}
                    >
                      <Box>
                        <DateCalendar
                          views={["month", "year"]}
                          maxDate={dayjs()}
                          sx={{
                            width: "auto",
                            height: "auto",
                          }}
                          value={selectedDate}
                          onChange={handleDateChange}
                        />
                      </Box>
                    </Menu>
                  </div>
                </LocalizationProvider>
              </Stack>
              <Table sx={{ borderCollapse: "collapse" }}>
                <TableHead>
                  <TableRow
                    sx={{
                      background: "#F4F9FF",
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                    }}
                  >
                    <TableCell
                      className={Styles.TableCardHeaderText}
                      sx={{ border: "1px solid #E0E0E0", borderLeft: "none" }}
                    >
                      Project
                    </TableCell>
                    <TableCell
                      align="center"
                      className={Styles.TableCardHeaderText}
                      sx={{ border: "1px solid #E0E0E0" }}
                    >
                      To do
                    </TableCell>
                    <TableCell
                      align="center"
                      className={Styles.TableCardHeaderText}
                      sx={{ border: "1px solid #E0E0E0" }}
                    >
                      In Progress
                    </TableCell>
                    <TableCell
                      align="center"
                      className={Styles.TableCardHeaderText}
                    // sx={{ border: "1px solid #E0E0E0" }}
                    >
                      Completed
                    </TableCell>
                    <TableCell
                      align="center"
                      className={Styles.TableCardHeaderText}
                    // sx={{ border: "1px solid #E0E0E0" }}
                    >
                      Production
                    </TableCell>
                    <TableCell
                      align="center"
                      className={Styles.TableCardHeaderText}
                      sx={{ border: "1px solid #E0E0E0", borderRight: "none" }}
                    >
                      Total
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={Styles.TableBody}>
                  {clientData?.projectTask?.map((row, index) => (
                    <TableRow
                      key={row.label}
                      sx={{
                        // "&:last-child td": {
                        //   borderBottom: "1px solid #E0E0E0",
                        // },
                        borderRight: "none",
                      }}
                    >
                      <TableCell
                        align="center"
                        className={Styles.TableCardText}
                        sx={{
                          // border: "1px solid #E0E0E0",
                          // borderLeft: "none",
                          // borderRight: "none",
                          // borderBottom:
                          //   index === clientData.projectTask.length - 1
                          //     ? "1px solid #E0E0E0"
                          //     : "1px solid #E0E0E0",
                        }}
                      >
                        {row.projectName}
                      </TableCell>
                      <TableCell
                        align="center"
                        className={Styles.TableCardText}
                      // sx={{ borderRight: "none" }}
                      >
                        {row.taskCounts.ToDo}
                      </TableCell>
                      <TableCell
                        align="center"
                        className={Styles.TableCardText}
                      // sx={{ border: "1px solid #E0E0E0" }}
                      >
                        {row.taskCounts.InProgress}
                      </TableCell>
                      <TableCell
                        align="center"
                        className={Styles.TableCardText}
                      // sx={{ border: "1px solid #E0E0E0" }}
                      >
                        {row.taskCounts.Completed}
                      </TableCell>
                      <TableCell
                        align="center"
                        className={Styles.TableCardText}
                      // sx={{ border: "1px solid #E0E0E0" }}
                      >
                        {row.taskCounts.Production}
                      </TableCell>
                      <TableCell
                        align="center"
                        className={Styles.TableCardText}
                        sx={{
                          // border: "1px solid #E0E0E0",
                          // borderRight: "none",
                          // borderBottom:
                          //   index === clientData.projectTask.length - 1
                          //     ? "1px solid #E0E0E0"
                          //     : "1px solid #E0E0E0",
                        }}
                      >
                        {row.taskCounts.totalCount}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Card>
          </Grid>

          <Grid mt={2} sx={{ position: "relative", pb: { xs: 1, md: 10 } }}>
            <Card className={Styles.TableCard}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Grid>
                  <Typography
                    variant="h6"
                    sx={{
                      ml: 2,
                      fontSize: "16px",
                      fontWeight: 600,
                      lineHeight: "24px",
                      fontFamily: "Inter, sans-serif",
                    }}
                  >
                    Task Progress
                  </Typography>
                </Grid>
                <Grid sx={{ width: "200px" }}>
                  <Autocomplete
                    options={[{ value: 'All', label: 'All Projects' }, ...clientProject]}
                    getOptionLabel={(option) => option.label || option.value}
                    value={selectedClientProject}
                    onChange={(event, newValue) => {
                      setSelectedClientProject(newValue);
                    }}
                    disableClearable
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        focused={false}
                        placeholder="Select Project"
                        className="AutoComplete_InputBox"
                        inputProps={{
                          ...params.inputProps,
                          style: {
                            marginRight: "20px",
                            cursor: "pointer",
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
              </Box>
              <Box sx={{ textAlign: "center", p: 1 }}>
                <Box className={Styles.progressCard}>
                  {(() => {
                    let filteredProjects = clientData?.projectTask || [];
                    if (selectedClientProject?.value !== 'All') {
                      filteredProjects = filteredProjects.filter(
                        (project) => project.projectName === selectedClientProject?.value
                      );
                    }
                    // If 'All' is selected, show aggregate progress for all projects
                    if (selectedClientProject?.value === 'All') {
                      // Aggregate task counts
                      const totalCounts = { ToDo: 0, InProgress: 0, Completed: 0, Production: 0, totalCount: 0 };
                      filteredProjects.forEach((project) => {
                        totalCounts.ToDo += project.taskCounts.ToDo;
                        totalCounts.InProgress += project.taskCounts.InProgress;
                        totalCounts.Completed += project.taskCounts.Completed;
                        totalCounts.Production += project.taskCounts.Production;
                        totalCounts.totalCount += project.taskCounts.totalCount;
                      });
                      const calculatePercentage = (taskCount) => {
                        if (totalCounts.totalCount > 0) {
                          return ((taskCount / totalCounts.totalCount) * 100).toFixed();
                        }
                        return 0;
                      };
                      return (
                        <React.Fragment>
                          <ProgressItem label="To Do" value={calculatePercentage(totalCounts.ToDo)} />
                          <ProgressItem label="In Progress" value={calculatePercentage(totalCounts.InProgress)} />
                          <ProgressItem label="Completed" value={calculatePercentage(totalCounts.Completed)} />
                          <ProgressItem label="Production" value={calculatePercentage(totalCounts.Production)} />
                        </React.Fragment>
                      );
                    }
                    // Otherwise, show progress for the selected project
                    return filteredProjects.map((project, index) => {
                      const { taskCounts } = project;
                      const totalCount = taskCounts.totalCount;
                      const calculatePercentage = (taskCount) => {
                        if (totalCount > 0) {
                          return ((taskCount / totalCount) * 100).toFixed();
                        }
                        return 0;
                      };
                      return (
                        <React.Fragment key={index}>
                          <ProgressItem label="To Do" value={calculatePercentage(taskCounts.ToDo)} />
                          <ProgressItem label="In Progress" value={calculatePercentage(taskCounts.InProgress)} />
                          <ProgressItem label="Completed" value={calculatePercentage(taskCounts.Completed)} />
                          <ProgressItem label="Production" value={calculatePercentage(taskCounts.Production)} />
                        </React.Fragment>
                      );
                    });
                  })()}
                </Box>
              </Box>
            </Card>
          </Grid>
        </Grid>

        <Grid
          size={{ xs: 12, sm: 12, md: 5, lg: 4 }}
          sx={{
            width: "100%",
            overflow: "scroll",
            height: "100vh",
          }}
          className={`${Styles.rightGrid} no-scrollbar`}
        >
          <Card className={Styles.rightSecondCard}>
            <Box className={Styles.calendarSection}>
              <Box className={Styles.calendarHeader}>

                <Typography
                  className={Styles.calendarMonth}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: "space-around",
                    gap: 1,
                    width: '100%',
                  }}
                >
                  <Button
                    sx={{ minWidth: 32 }}
                    onClick={() => setCalendarSelectedDate(calendarSelectedDate.subtract(1, 'month'))}
                  >
                    <ArrowBackIosNewIcon fontSize="small" sx={{ color: "black" }} />
                  </Button>
                  <span style={{ minWidth: 120, textAlign: 'center', fontWeight: 500 }}>
                    {calendarSelectedDate.format("MMMM YYYY")}
                  </span>
                  <Button
                    sx={{ minWidth: 32 }}
                    onClick={() => setCalendarSelectedDate(calendarSelectedDate.add(1, 'month'))}
                  >
                    <ArrowForwardIosIcon fontSize="small" sx={{ color: "black" }} />
                  </Button>
                </Typography>
              </Box>

              <Box className={Styles.weekDays}>
                {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map(
                  (day) => (
                    <Typography key={day} className={Styles.weekDay}>
                      {day}
                    </Typography>
                  )
                )}
              </Box>

              {/* Calendar Grid - independent, allows future months, uses allCalendarData */}
              <Box className={Styles.calendarGrid}>
                {(() => {
                  // Generate days for the selected month (future months allowed)
                  const currentDate = calendarSelectedDate.toDate();
                  const year = currentDate.getFullYear();
                  const month = currentDate.getMonth();
                  const firstDay = new Date(year, month, 1);
                  const lastDay = new Date(year, month + 1, 0);
                  const startingDayOfWeek = firstDay.getDay();
                  const daysFromPrevMonth = startingDayOfWeek;
                  const totalDays = lastDay.getDate();
                  const endingDayOfWeek = lastDay.getDay();
                  const daysFromNextMonth = 6 - endingDayOfWeek;
                  const days = [];
                  const prevMonthLastDay = new Date(year, month, 0).getDate();
                  for (let i = prevMonthLastDay - daysFromPrevMonth + 1; i <= prevMonthLastDay; i++) {
                    days.push({ date: new Date(year, month - 1, i), isCurrentMonth: false });
                  }
                  for (let i = 1; i <= totalDays; i++) {
                    const dateObj = new Date(year, month, i);
                    // Check if this date is a holiday in allCalendarData
                    const isHoliday = allCalendarData.some((holiday) => {
                      const holidayDate = new Date(holiday.date);
                      return (
                        holidayDate.getDate() === dateObj.getDate() &&
                        holidayDate.getMonth() === dateObj.getMonth() &&
                        holidayDate.getFullYear() === dateObj.getFullYear()
                      );
                    });
                    const isToday = dayjs(dateObj).isSame(dayjs(), "day");
                    days.push({ date: dateObj, isCurrentMonth: true, isHoliday, isToday });
                  }
                  for (let i = 1; i <= daysFromNextMonth; i++) {
                    days.push({ date: new Date(year, month + 1, i), isCurrentMonth: false });
                  }
                  return days.map((day, index) => (
                    <Box
                      key={index}
                      className={`${Styles.calendarDay} ${day.isHoliday ? Styles.holidayDay : ""
                        } ${!day.isCurrentMonth ? Styles.otherMonthDay : ""}`}
                      sx={{
                        ...(day.isToday && {
                          backgroundColor: "#2B6AB1 !important",
                          borderRadius: "50% !important",
                          "& .MuiTypography-root": {
                            color: "white !important",
                          },
                        }),
                      }}
                    >
                      <Typography className={Styles.dayNumber}>
                        {day.date.getDate()}
                      </Typography>
                    </Box>
                  ));
                })()}
              </Box>
            </Box>

            {/* Holidays Carousel */}

            <Box className={Styles.holidaysCarousel}>
              {clientData?.publicHoliday?.length > 0 ? (
                <Swiper
                  modules={[Pagination, Navigation, Autoplay]}
                  direction="vertical"
                  slidesPerView={3}
                  slidesPerGroup={1}
                  spaceBetween={16}
                  pagination={false}
                  navigation={false}
                  loop={true}
                  autoplay={{
                    delay: 1500, // time between transitions (ms)
                    disableOnInteraction: false, // keep autoplay running even after user interaction
                  }}
                  style={{ height: "30vh" }}
                >
                  {clientData.publicHoliday.map((holiday, index) => {
                    const date = new Date(holiday?.date);
                    const day = date.getDate();
                    const suffix = getDaySuffix(day);
                    const formattedDate = `${day}${suffix} ${date.toLocaleDateString(
                      "en-US",
                      { month: "short" }
                    )}, ${date.getFullYear()}`;
                    const dayName = date.toLocaleString("en-US", {
                      weekday: "long",
                    });

                    return (
                      <SwiperSlide key={index}>
                        <Box
                          sx={{
                            background: "#F4F8FF",
                            padding: "10px",
                            borderRadius: "8px",
                          }}
                        >
                          <Stack
                            direction={"row"}
                            justifyContent={"space-between"}
                          >
                            <Stack spacing={1}>
                              <Typography className={Styles.leaveheader}>
                                {holiday?.name}
                              </Typography>
                              <Typography className={Styles.leaveSubheader}>
                                {holiday?.description}
                              </Typography>
                            </Stack>
                            <Stack spacing={1}>
                              <Typography className={Styles.leaveheader}>
                                {formattedDate}
                              </Typography>
                              <Typography className={Styles.leaveSubheader}>
                                {dayName}
                              </Typography>
                            </Stack>
                          </Stack>
                        </Box>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              ) : (
                <Stack alignItems={"center"} mt={3}>
                  <img
                    src={PublicHoliday_NoData}
                    alt="No Public Holiday"
                    height={"87px"}
                    width={"87px"}
                  />
                  <Typography sx={{ fontWeight: 700, fontSize: "16px", mt: 2 }}>
                    No Upcoming Holidays
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: "14px",
                      textAlign: "center",
                      padding: "0 50px",
                      mt: 1,
                    }}
                  >
                    No public holidays to show for this month and the next.
                  </Typography>
                </Stack>
              )}
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ClientDashboard;
